import React from "react";
import {NavLink} from "react-router-dom";

const TicketItem = ({element}) => {
    return (
        <NavLink to="" className="ticket font-mont">
            <div className="ticket-article">
                <span className="ticket-subject">EVENT</span>
                <h4 className="ticket-info">{element.event_name}</h4>
            </div>
            <div className="ticket-article">
                <span className="ticket-subject">DATE</span>
                <h4 className="ticket-info">{element.start_date} PM</h4>
            </div>
            <div className="ticket-article">
                <span className="ticket-subject">VENUE</span>
                <h4 className="ticket-info">{element.metahut_name}</h4>
            </div>
            <div className="ticket-article">
                <span className="ticket-subject">TICKET</span>
                <h4 className="ticket-info color-burn">#{element.ticket_id}</h4>
            </div>
        </NavLink>
    )
}

export default TicketItem;